"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXNoteLike = exports.HTMLNoteLike = exports.HTMLNoteLikeCSS = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../common/html");
const component_1 = require("../common/docx/component");
const any_1 = require("./any");
exports.HTMLNoteLikeCSS = `

`;
exports.HTMLNoteLike = (0, html_1.wrapHTMLComponent)("HTMLNoteLike", ((props) => {
    const { el, htmlOptions, indent } = props;
    return (react_1.default.createElement("div", { className: "note-like", ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(any_1.HTMLAnyELs, { els: el.children, indent: indent, htmlOptions })));
}));
exports.DOCXNoteLike = (0, component_1.wrapDOCXComponent)("DOCXNoteLike", ((props) => {
    const { el, docxOptions, indent } = props;
    return react_1.default.createElement(any_1.DOCXAnyELs, { els: el.children, indent: indent, docxOptions });
}));
//# sourceMappingURL=noteLike.js.map